import { useContext } from "react";
import { Typography } from "antd";
import { MoonFilled, SunFilled } from "@ant-design/icons";

import ThemeContext from "../../utils/context/Theme/ThemeContext";

const ChangeTheme = () => {
  const { themeMode, handleChangeTheme } = useContext(ThemeContext);

  return (
    <Typography.Text className="theme-switch" onClick={handleChangeTheme}>
      {themeMode === "dark" ? <SunFilled /> : <MoonFilled />}
    </Typography.Text>
  );
};

export default ChangeTheme;
